import { render, staticRenderFns } from "./MetricsSummaryPage.vue?vue&type=template&id=3677e6f7&"
import script from "./MetricsSummaryPage.vue?vue&type=script&lang=js&"
export * from "./MetricsSummaryPage.vue?vue&type=script&lang=js&"
import style0 from "./MetricsSummaryPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports